module.exports = __webpack_public_path__ + "img/loading_white.b3281e36.png";